import styles from './LinkHandler.module.less';

interface LinkHandlerOptions {
  openArtistModal: (slug: string) => void;
  openFormModal: () => void;
  theme: string;
}

export const setupLinkHandlers = (
  containerElement: HTMLElement,
  options: LinkHandlerOptions
): (() => void) => {
  const cleanup: (() => void)[] = [];

  if (!document.getElementById('link-icons')) {
    const svgSprite = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );
    svgSprite.id = 'link-icons';
    svgSprite.style.display = 'none';
    svgSprite.innerHTML = `
      <symbol id="back" viewBox="0 0 32 32">
        <path stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="10" stroke-width="4" d="M21.426 8.007h-5.904l-10.554 8.003 10.554 7.984h5.904"></path>
        <path stroke-linejoin="miter" stroke-linecap="butt" stroke-miterlimit="10" stroke-width="4" d="M27.031 16.009h-21.469"></path>
      </symbol>
    `;
    document.body.appendChild(svgSprite);
  }

  const links = containerElement.querySelectorAll('a');
  

  links.forEach((link) => {
    link.classList.add(styles.link);

    if (link.classList.contains(styles.processed)) {
      return;
    }

    link.classList.add(styles.processed);
    link.setAttribute('data-theme', options.theme);

    const href = link.getAttribute('href');

    if (href?.startsWith('/artist/')) {
      link.classList.add(styles.artistLink);
      const handleClick = (e: Event) => {
 
        e.preventDefault();
        const slug = href.split('/artist/')[1];
        options.openArtistModal(slug);
      };
      link.addEventListener('click', handleClick);
      cleanup.push(() => link.removeEventListener('click', handleClick));
    } else if (href === '/form') {
      link.classList.add(styles.formLink);
      const handleClick = (e: Event) => {
        e.preventDefault();
        options.openFormModal();
      };
      link.addEventListener('click', handleClick);
      cleanup.push(() => link.removeEventListener('click', handleClick));
    } else if (link.hostname !== window.location.hostname) {
      const existingWrappers = link.querySelectorAll(`.${styles.test}`);
      existingWrappers.forEach((wrapper) => wrapper.remove());

      link.classList.add(styles.externalLink);
      link.setAttribute('rel', 'noopener noreferrer');
      link.setAttribute('target', '_blank');

      const iconWrapper = document.createElement('div');
      iconWrapper.classList.add(styles.test);
      iconWrapper.setAttribute('data-theme', options.theme);

      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.classList.add(styles.icon);
      svg.setAttribute('data-theme', options.theme);
      svg.innerHTML = '<use href="#back"></use>';

      iconWrapper.appendChild(svg);
      link.appendChild(iconWrapper);
    }
  });

  return () => {
    cleanup.forEach((fn) => fn());
  };
};
